<template lang="pug">
  .listing-item
    v-card.round-xl(outlined)
      .pa-4
        .text-sm.font-semibold {{ name }}
        .text-xs.font-normal.neutral500--text {{ dateTime }}
      v-divider.mb-4
      .d-flex.align-center.mb-4.mx-1.gap-1.flex-wrap
        v-btn.button-xs(outlined color="neutral700" :disabled="isDisabledWhatsapp" @click="$emit('clickWhatsapp')") Send WhatsApp
        v-btn.button-xs(outlined color="neutral700" :disabled="isDisabledSms" @click="$emit('clickSms')") Send SMS
        v-btn.button-xs(outlined color="neutral700" :disabled="isDisabledEmail" @click="$emit('clickEmail')") Send Email
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    dateTime: {
      type: String,
      required: true
    },
    isDisabledWhatsapp: {
      type: Boolean,
    },
    isDisabledEmail: {
      type: Boolean,
    },
    isDisabledSms: {
      type: Boolean,
    },
  },
  computed: {
    isMobileScreen() {
      return this.$vuetify.breakpoint.xs
    },
  },
  methods: {
    isDisabled(actionType, item) {
      let disabled;
      switch (actionType) {
        case 'sms':
        case 'whatsapp':
          disabled = !item.lead.phone
          break;

        case 'email':
          disabled = !item.lead.email
          break;

        default:
          break;
      }
      return disabled
    }
  },
}
</script>

<style scoped>
</style>